import { FeatureCooldownType } from '../../../../../app/state/cooldowns/types';
import { getLocalizedString } from '../../../../../app/localization/getLocalizedString';
import { CountDownFormat, formatFixedCountdown } from '../../../../../utils/time-utils';
import type { App } from '../../../../../app/App';
import { sendLifeRequest } from '../../../../../app/platform/facebook/sendLifeRequest';
import { getFeatureCooldownTime } from '../../../../../app/state/cooldowns/getFeatureCooldownTime';
import type { AskForLivesButtonLayout } from '../../../../../libs/layouts/types/LayoutShapes';

export class AskForLivesButtonController {
  #enabled = true;

  constructor(
    private readonly app: App,
    private readonly layout: AskForLivesButtonLayout,
  ) {
    layout.askForLivesButton.onpointertap = (): void => {
      void this.sendLifeRequest();
    };
  }

  public update(): void {
    const { stateController } = this.app;

    const timeRemaining = stateController.getFeatureCooldownTime(FeatureCooldownType.LifeRequest);
    const lifeRequestOnCooldown = timeRemaining > 0;

    if (lifeRequestOnCooldown) this.updateCountDownText(timeRemaining);

    this.enabled = !lifeRequestOnCooldown;
  }

  private updateCountDownText(timeRemaining: number): void {
    const { askFriendCountdownText } = this.layout;
    askFriendCountdownText.text = getLocalizedString(
      `!{Ready in} ${formatFixedCountdown(timeRemaining, CountDownFormat.MS)}`,
    );
  }

  private async sendLifeRequest(): Promise<void> {
    const { stateController, resources, platform } = this.app;
    const { askForLivesButton } = this.layout;

    askForLivesButton.interactive = false;

    const onAskSuccess = (): void => {
      resources.addLifeQuestReward();
      stateController.setFeatureCooldownTime(
        FeatureCooldownType.LifeRequest,
        getFeatureCooldownTime(FeatureCooldownType.LifeRequest),
      );
    };

    const success = await sendLifeRequest(platform);
    if (success) onAskSuccess();

    askForLivesButton.interactive = true;
  }

  set enabled(value: boolean) {
    if (this.#enabled === value) return;
    this.#enabled = value;

    const { askForLivesButton, askFriendCooldownGroup, askFriendReadyGroup } = this.layout;
    askFriendReadyGroup.root.visible = this.#enabled;
    askFriendCooldownGroup.root.visible = !this.#enabled;

    askForLivesButton.interactive = this.#enabled;
  }

  get enabled(): boolean {
    return this.#enabled;
  }
}
